
import state from './moduleTranksaksiState.js'
import mutations from './moduleTranksaksiMutations.js'
import actions from './moduleTranksaksiActions.js'
import getters from './moduleTranksaksiGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
